module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1104.20d6a462.png";